// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__wacZD","notes":"Notes_notes__2_UlH"};